// **********************************************************
// Product Card Slider
// **********************************************************

const productCardSlider = document.querySelectorAll('[data-slider="product-card-slider"]');

const productCardSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 20,
  speed: 600,
  loop: true,
  breakpoints: {
    767: {
      slidesPerView: 2,
      slidesPerGroup: 2,
    },
    1023: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
    1199: {
      slidesPerView: 4,
      slidesPerGroup: 4,
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

productCardSlider.forEach((el) => {
  const productCardSliderParent = el.closest('.product-card-slider');
  const arrowRight = productCardSliderParent.querySelector('.arrow-right');
  const arrowLeft = productCardSliderParent.querySelector('.arrow-left');

  productCardSliderOptions.navigation.nextEl = arrowRight;
  productCardSliderOptions.navigation.prevEl = arrowLeft;

  new Swiper(el, productCardSliderOptions);
});

// **********************************************************
// Product Popup Ajax
// **********************************************************

const productPopupDetailAjax = (element) => {
  const productId = element.closest('.product-card').getAttribute('data-product-id');
  const productPopupMain = document.querySelector('.product-popup-wrapper');

  const ajaxData = new FormData();
  ajaxData.append('action', 'getProductCardSliderPopup');
  ajaxData.append('productId', productId);
  ajaxData.append('lang', localData.lang);

  axios
    .post(localData.apiURL, ajaxData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      productPopupMain.innerHTML = response.data.data.popupDetail;
      listenToVariationChange();
      initShowcase();
      // GTAG - view_product event
      const dataLayer = window.dataLayer || [];
      dataLayer.push({ ecommerce: null });
      dataLayer.push(response.data.data.view_item);
      // GTAG - view_product event
    })
    .catch((err) => {
      console.error(err);
    });
};

// **********************************************************
// Open Product Popup
// **********************************************************

attachEvent('.product-card__button', 'click', (ev) => {
  const productPopup = document.querySelector('.product-popup');
  if (productPopup) {
    productPopup.classList.toggle('is-open-modal');
    const isOpen = productPopup.classList.contains('is-open-modal');
    ev.preventDefault();
    toggleBodyScrollLock(isOpen);
    productPopupDetailAjax(ev.target);
  }
});
